import "./loading.css";

const Loading = () => {
    return (
        <div className="loading">
            <div className="spinner-container">
                <div className="loading-spinner"></div>
            </div>
        </div>
    )
}
export default Loading;
